import React from 'react';
import BasicContactStep from './BasicContactStep';
import PersonalDetailsStep from './PersonalDetailsStep';
import PreferenceInformationStep from './PreferenceInformationStep';
import ScheduleStep from './ScheduleStep';
import EmergencyContactStep from './EmergencyContactStep';
import ReviewStep from './ReviewStep';

export interface StepContentProps {
  activeStep: number;
  isMobile?: boolean;
  isSaving: boolean;
  onEditSection?: (stepIndex: number) => void;
}

const StepContent: React.FC<StepContentProps> = ({
  activeStep,
  isMobile = false,
  isSaving,
  onEditSection
}) => {
  switch (activeStep) {
    case 0:
      return <BasicContactStep isMobile={isMobile} isSaving={isSaving} />;
    case 1:
      return <PersonalDetailsStep isSaving={isSaving} />;
    case 2:
      return <ReviewStep isSaving={isSaving} isMobile={isMobile} onEditSection={onEditSection} />;
    default:
      return null;
  }
};
export const StepContent2: React.FC<StepContentProps> = ({
  activeStep,
  isMobile = false,
  isSaving,
  onEditSection
}) => {
  switch (activeStep) {
    case 0:
      return <PreferenceInformationStep isSaving={isSaving} />;
    case 1:
      return <ScheduleStep isSaving={isSaving} />;
    case 2:
      return <EmergencyContactStep isSaving={isSaving} />;
    default:
      return null;
  }
};

export default React.memo(StepContent);